import { Link } from 'tiptap-extensions'
export default class CustomLink extends Link {
  get name() {
    return 'link'
  }

  get defaultOptions() {
    return {
      target: ['_self', '_blank'],
    }
  }

  get schema() {
    return {
      attrs: {
        href: {
          default: null,
        },
        target: {
          default: null,
        },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: (dom) => ({
            href: dom.getAttribute('href'),
            target: dom.getAttribute('target'),
          }),
        },
      ],
      toDOM: (node) => [
        'a',
        {
          ...node.attrs,
          target: node.attrs.target,
        },
        0,
      ],
    }
  }
}
